import { Component } from '@angular/core';
import { ColorsService } from '../../services/colors.service';
import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-color-text-settings',
  templateUrl: './color-text-settings.component.html',
  styleUrls: ['./color-text-settings.component.css']
})
export class ColorTextSettingsComponent {
  screen:any={
    headerColor:'#361F30',
    sideBarColor:'#d2e1f5'

  }
  backgroundColorValue: string = '#45B3DC';
  PrimaryColor:any

  constructor(private data:ColorsService,private route:Router){
    
  }
   propertylist:any = [
    "accent-color",
    "align-content",
    "align-items",
    "align-self",
    //"all",
    "animation",
    //"animation-delay",
    //"animation-direction",
    //"animation-duration",
    //"animation-fill-mode",
    //"animation-iteration-count",
    //"animation-name",
    //"animation-play-state",
    //"animation-timing-function",
    //"backface-visibility",
    "aspect-ratio",
    "backdrop-filter",
    "background",
    //"background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-position-x",
    "background-position-y",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-end-end-radius",
    "border-end-start-radius",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-start-end-radius",
    "border-start-start-radius",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    //"box-decoration-break",
    "box-reflect",
    "box-shadow",
    "box-sizing",
    //"break-after",
    //"break-before",
    //"break-inside",
    "caption-side",
    //"caret-color",
    //"@charset",
    "clear",
    "clip",
    "clip-path",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    //"content",
    //"counter-increment",
    //"counter-reset",
    //"cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    //"flex-shrink",
    "flex-wrap",
    "float",
    "font",
    //"@font-face",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-size",
    //"font-size-adjust",
    //"font-stretch",
    "font-style",
    "font-variant",
    "font-variant-caps",
    "font-weight",
    "gap",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-gap",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-gap",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    //"hanging-punctuation",
    "height",
    "hyphens",
    "image-rendering",
    //"@import",
    //"isolation",
    "inline-size",
    "inset",
    "inset-block",
    "inset-block-end",
    "inset-block-start",
    "inset-inline",
    "inset-inline-end",
    "inset-inline-start",
    "justify-content",
    "justify-items",
    "justify-self",
    //"@keyframes",
    "left",
    "letter-spacing",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    //"mask-image",
    //"mask-mode",
    //"mask-origin",
    //"mask-position",
    //"mask-repeat",
    //"mask-size",
    //"max-height",
    //"max-width",
    //"@media",
    "max-block-size",
    "max-inline-size",
    "min-block-size",
    "min-inline-size",
    "min-height",
    "min-width",
    "mix-blend-mode",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    //"orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "paint-order",
    //"page-break-after",
    //"page-break-before",
    //"page-break-inside",
    "perspective",
    "perspective-origin",
    "place-content",
    "place-items",
    "place-self",
    //"pointer-events",
    //"position",
    "quotes",
    //"resize",
    "right",
    "rotate",
    "row-gap",
    "scale",
    //"scroll-behavior",
    //"scroll-margin",
    //"scroll-margin-block",
    //"scroll-margin-block-end",
    //"scroll-margin-block-start",
    //"scroll-margin-bottom",
    //"scroll-margin-inline",
    //"scroll-margin-inline-end",
    //"scroll-margin-inline-start",
    //"scroll-margin-left",
    //"scroll-margin-right",
    //"scroll-margin-top",
    //"scroll-padding",
    //"scroll-padding-bottom",
    //"scroll-padding-block",
    //"scroll-padding-block-end",
    //"scroll-padding-block-start",
    //"scroll-padding-inline",
    //"scroll-padding-inline-end",
    //"scroll-padding-inline-start",
    //"scroll-padding-left",
    //"scroll-padding-right",
    //"scroll-padding-top",
    //"scroll-scroll-align",
    //"scroll-scroll-stop",
    //"scroll-scroll-type",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-last",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-indent",
    //"text-justify",
    "text-orientation",
    "text-overflow",
    "text-shadow",
    "text-transform",
    "top",
    "transform",
    "transform-origin",
    "transform-style",
    //"transition",
    //"transition-delay",
    //"transition-duration",
    //"transition-property",
    //"transition-timing-function",
    "translate",
    "unicode-bidi",
    //"user-select",
    "vertical-align",
    "visibility",
    "white-space",
    //"widows",
    "width",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"];


    colorChange(){
     
sessionStorage.setItem("userData",JSON.stringify(this.backgroundColorValue));
sessionStorage.setItem("screenData",JSON.stringify(this.screen));

      this.data.colors(this.backgroundColorValue,this.screen)
      //this.route.navigate(["/app/Activity"]);
      window.location.href="/app/Activity"
    }
}
